import './../scss/style.scss';
//  import Bootstrap 
require('bootstrap');

import { WCAG } from "rytm-wcag";
import RytmWebflow from 'rytm-webflow'
import { initCommon } from './shared/common'
import { initModwideo } from './sm/modwideo';

import { loadingSequence } from './loading';

WCAG.init()
initCommon()
initModwideo()
RytmWebflow.showUp.rebuild()

loadingSequence()